<div class="headline">
  <span>
    {{ 'home.users.overview.title' | translate }}
    <span *ngIf="(users$ | async) as u">
      ({{ u.totalElements }})
    </span>
  </span>
  <div class="controls">
    <button class="btn btn-primary" type="button" (click)="onCreateUser()" *appAdminOnlyDirective>
      <i class="fas fa-user-plus"></i>
    </button>
    <input type="text" class="input small-input" [placeholder]="'home.users.overview.search' | translate" (input)="onFilterChange($event.target.value)">
  </div>
</div>
<ng-container *ngIf="(users$ | async) as users">
  <app-overview-user-table
    class="overview-table"
    [users]="users.content"
    (deleteUser)="onDeleteUser($event)"
    (editUser)="onEditUser($event)"
  ></app-overview-user-table>
  <app-pagination
    [page]="users.number + 1"
    [size]="users.size"
    [totalElements]="users.totalElements"
    (pageSelected)="onPageSelected($event - 1)"
    (sizeSelected)="onSizeSelected($event)"
  ></app-pagination>
</ng-container>

